import EllipseLoader from '@assets/animations/EllipseLoader.json';
import ModakLoader from '@assets/animations/ModakLoader.json';

export const CSpinner = {
  PATH: ModakLoader,
  ELLIPSE_PATH: EllipseLoader,
};
